import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface MfaPolicy {
  can_self_manage: boolean;
  is_required: boolean;
  is_enrolled: boolean;
  reason: string;
  organization_id: number | null;
  has_password: boolean;
}

/**
 * MFA policy for the calling user. Drives the Account Security panel:
 * `can_self_manage` gates the enroll toggle, and `is_required` triggers
 * a break-glass banner for unenrolled Owners.
 */
export const useMfaPolicy = () => {
  const userToken = useAuth()?.userToken;
  return useQuery<MfaPolicy>({
    queryKey: ["mfa", "policy"],
    enabled: Boolean(userToken),
    queryFn: async () =>
      fetch(ENDPOINTS.mfa.policy, {
        headers: { Authorization: `Bearer ${userToken ?? ""}` },
      }).then(handleResponse),
  });
};
